import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import baseStyle from './index.css?url'
import OscarProvider, {OscarConfig} from "@/components/context/OscarContext.tsx";
import ErrorBoundary from "@/components/overlay/ErrorBoundary.tsx";
import * as Sentry from "@sentry/react";
import {BookingKind} from "@/lib/enum/BookingKind.ts";

if (import.meta.env.MODE == "development") {
    console.log('Running in development mode');
} else {
    // Sentry
    Sentry.init({
        dsn: "https://fc3a32c4f40c6d7a6fb4e9c93e9f5769@o53950.ingest.us.sentry.io/4507812126392320",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        ignoreErrors: ['elementorFrontend'], // Ignore errors from certain sources
    });
}

// Build data for Oscar
const domRoot = document.getElementById('oscar-app');
if (domRoot) {
    // Add CSS to page.
    const styleLink = document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.href = baseStyle;
    document.head.appendChild(styleLink);

    // Parse the URL
    const currUrl = new URL(window.location.href);

    // Load branding.
    const brand = domRoot.dataset.brand ?? 'act_skip_hire';

    if (brand === 'act_skip_hire') {
        domRoot.classList.add('os-brand-actskiphire');
    } else if (brand === 'angel_waste') {
        domRoot.classList.add('os-brand-angelwaste');
    } else if (brand === "cut_price_skips") {
        domRoot.classList.add('os-brand-cutpriceskips');
    } else if (brand === "capital_hire") {
        domRoot.classList.add('os-brand-capitalhire');
    } else if (brand === "crg_skips") {
        domRoot.classList.add('os-brand-crgskips');
    } else if (brand === "cbr_skips") {
        domRoot.classList.add('os-brand-cbrskips');
    } else if (brand === "discount_skips_wb") {
        domRoot.classList.add('os-brand-discountskipswb');
    } else if (brand === "budget_wb") {
        domRoot.classList.add('os-brand-budgetwb');
    }

    // Default bin kind.
    let binKind = BookingKind.BIN;
    if (domRoot.dataset.binKind === 'bag') {
        binKind = BookingKind.BAG;
    } else if (currUrl.searchParams.get('oscar-bin-kind') === 'bag') {
        binKind = BookingKind.BAG;
    }

    // Build the config.
    const config = {
        brand: brand,
        showHeader: domRoot.dataset.showHeader === 'true',
        calendarCount: domRoot.dataset.calendarCount ?? 2,
        communityBooking: domRoot.dataset.communityBooking === 'true',
        tightMode: brand === "cut_price_skips",
        defaultBinKind: binKind,
    } as OscarConfig;

    ReactDOM.createRoot(domRoot).render(
        <React.StrictMode>
            <div className={"os-app-root os-p-1 !os-break-normal"}>
                <ErrorBoundary>
                    <OscarProvider localConfig={config}>
                        <App />
                    </OscarProvider>
                </ErrorBoundary>
            </div>
        </React.StrictMode>,
    )
}